import { MixinStyledInput } from "components/Input/styles";
import styled from "styled-components/macro";
import { BannerFont, DefaultFont } from "../../../styles/fonts";

export const ContactP = styled.p`
  flex: 1 1 40%;

  ${DefaultFont}

  & > a {
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const ContactTitle = styled.h1`
  ${BannerFont}

  & > span {
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const ContactImg = styled.img`
  border-radius: 8px;
  object-fit: cover;
  min-width: 20em;
  flex: 1 1 40%;

  width: 100%;
  aspect-ratio: 4 / 3;
`;

export const ContactGrid = styled.div`
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  align-items: center;

  gap: 2rem;
  margin-bottom: 10em;

  @media ${(props) => props.theme.media.phone} {
    margin-bottom: 3em;
  }
`;

export const FormSend = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  gap: 1.5625em;

  max-width: 688px;
  margin: 0 auto 240px;
  text-align: left;
  background-color: ${(props) => props.theme.colors.bgSecondary};
  padding: 1.5625em;
  border-radius: 6px;

  & > button {
    padding-top: 0.8em;
    padding-bottom: 0.8em;
    font-weight: ${(props) => props.theme.font.weightMedium};
    color: white;
    &:focus, :hover, :active {
      color: white;
    }
  }
  & > div > input {
    ${MixinStyledInput}
  }
  
  & > div > p {
    font-weight: 600;
    margin-bottom: 0.5em;
    font-size: 16px;
    @media ${(props) => props.theme.media.phone} {
      font-weight: 600;
    }
  }
  
  
  & #formTitle > h2 {
    margin: 0;

    font-size: ${(props) => props.theme.font.sizeSubTitle};
    font-weight: ${(props) => props.theme.font.weightMedium};
    font-family: ${(props) => props.theme.font.family};
    color: ${(props) => props.theme.colors.text};
  }

  //Grid start
  & #formTitle {
    grid-area: 1 / 1 / 1 / 3;
  }
  & #firstnameDiv {
    grid-area: 2 / 1 / auto / auto;
  }
  & #lastnameDiv {
    grid-area: 2 / 2 / auto / auto;
  }
  & #emailDiv {
    grid-area: 3 / 1 / auto / auto;
  }
  & #phoneDiv {
    grid-area: 3 / 2 / auto / auto;
  }
  & #categoryDiv {
    grid-area: 4 / 1 / auto / 3;
    .ant-radio-wrapper .ant-radio {
        align-self: flex-start;
        padding-top: 2px;
    }
  }
  & #questionDiv {
    grid-area: 5 / 1 / 5 / 3;
  }
  & > button {
    grid-area: 6 / 1 / auto / 3;
  }
  //Grid end
  
  @media ${(props) => props.theme.media.phone} {
    grid-template-columns: 100%;
    margin: 0 auto 24px;
    padding: 1rem;

    //Grid mobile start
    & #formTitle {
      grid-area: 1 / 1 / auto / auto;
    }
    & #firstnameDiv {
      grid-area: 2 / 1 / auto / auto;
    }
    & #lastnameDiv {
      grid-area: 3 / 1 / auto / auto;
    }
    & #emailDiv {
      grid-area: 4 / 1 / auto / auto;
    }
    & #phoneDiv {
      grid-area: 5 / 1 / auto / auto;
    }
    & #categoryDiv {
      grid-area: 6 / 1 / auto / auto;
    }
    & #questionDiv {
      grid-area: 7 / 1 / auto / auto;
    }
    & > button {
      grid-area: 8 / 1 / auto / auto;
    }
    //Grid mobile end
    }
  }
`;
